import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const ItemList = styled.li`
  position: relative;
  width: 100%;
`

export const SidebarButton = styled(Link)<{ $isCollapsed: boolean }>`
  position: relative;
  width: 100%;
  height: 40px;
  padding: 0px 1rem;
  margin: 0;

  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 0.5rem;

  border-radius: 4px;
  border: none;
  cursor: pointer;

  text-transform: none;
  text-decoration: none;
  overflow: hidden;

  * {
    pointer-events: none;
  }

  .arrowIcon svg {
    fill: ${props => props.theme.colors.color122d52};
    width: 7px;
  }

  .linkIcon {
    width: ${({ $isCollapsed }) => ($isCollapsed ? '100%' : '20px')};
    transition-delay: ${({ $isCollapsed }) => ($isCollapsed ? '0.3s' : '0s')};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  p {
    width: 100%;

    white-space: nowrap;
    font-family: 'Inter';
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
  }

  &.active {
    border: 1px solid transparent;
    background: ${props => props.theme.colors.colore4e8ef};
    p {
      color: ${props => props.theme.colors.color122d52};
    }
    svg {
      fill: ${props => props.theme.colors.color122d52};
    }
  }

  &.inactive {
    border: 1px solid transparent;
    background: ${props => props.theme.colors.colorf3f5f9};
    p {
      color: ${props => props.theme.colors.color545e6c};
    }
    svg {
      fill: ${props => props.theme.colors.color545e6c};
    }
  }

  &:hover,
  &:focus-visible {
    border: 1px solid ${props => props.theme.colors.color545e6c};
  }
`
